<template>
  <div>
    <v-slide-x-transition>
      <auth-user v-if="page == 'user'" @setUser="setUser($event)" @setPage="changePage($event)" @error="error = $event"></auth-user>
    </v-slide-x-transition>
    <v-slide-x-transition>
      <auth-password :user="user" v-if="page == 'password'" @setPage="changePage($event)" @error="error = $event"></auth-password>
    </v-slide-x-transition>
    <v-slide-x-transition>
      <auth-recovery :user="user" v-if="page == 'recovery'" :page="page" @setToken="setToken($event)" @setPage="changePage($event)" @error="error = $event"></auth-recovery>
    </v-slide-x-transition>
    <v-slide-x-transition>
      <auth-reset :user="user" v-if="page == 'reset'" @setPage="changePage($event)" @error="error = $event"></auth-reset>
    </v-slide-x-transition>
    <v-slide-x-transition>
      <auth-confirmation v-if="page == 'confirmation'" @error="error = $event"></auth-confirmation>
    </v-slide-x-transition>
    <!-- <v-snackbar style="top: 70px"  centered v-model="error.show" :timeout="10000" fixed bottom color="red">{{ error.text }}
      <template v-slot:action="{ attrs }">
          <v-btn color="red" small fab elevation="0" v-bind="attrs" @click="error.show = false">
              <v-icon>mdi-close</v-icon>
          </v-btn>
      </template>
  </v-snackbar>  -->
  </div>
</template>
<script>
import AuthUser from '@/components/auth/AuthUser.vue'
import AuthPassword from '@/components/auth/AuthPassword.vue';
import AuthRecovery from '@/components/auth/AuthRecovery.vue';
import AuthReset from '@/components/auth/AuthReset.vue';
import { mapActions } from 'vuex';
import AuthConfirmation from '@/components/auth/AuthConfirmation.vue';

export default {
  name: "AuthView",
  components: { AuthUser, AuthPassword, AuthRecovery, AuthReset, AuthConfirmation},
  data: () => ({
    user: {},
    page: 'user',
    error: {
      text: "",
      show: false
    }
  }),

watch: {
  error(nv) {
    this.showSnack({
            text: this.error.text,
            color: "error",
            timeout: 3800,
            icon: "mdi-check",
          });
  }
},


  mounted(){
    this.page = this.$route.path.includes('confirmacao') ? 'confirmation' : 'user'
  },
  methods: {
...mapActions("snackbar",["showSnack"]),

    setUser(event) {
      this.user = event
      this.changePage('password')
    },
    setToken(event) {
      this.user.token = event
      this.changePage('reset')
    },
    changePage(page) {
      this.page = ""
      setTimeout(() => {
        this.page = page
      }, 300)
    }
  }
}
</script> 